
export const cardsData = [
  {
    id: 1,
    logo: "MdCompost",
    title: "Effortless Job Posting",
    description: "Discover simplicity in posting your job requirements. Attract skilled content creators tailored to your project needs.",
    borderBottomColor: "rgba(1, 162, 142, 0.39)",
  },
  {
    id: 2,
    logo: "CiStreamOn",
    title: "Streamlined Recruitment",
    description: "Streamline your recruitment process with our platform. Find the perfect content creators effortlessly.",
    borderBottomColor: "rgba(229, 48, 62, 0.39)",
  },
  {
    id: 3,
    logo: "FaHandHoldingHeart",
    title: "Tailored Matches",
    description: "Get tailored matches for your project needs. Our platform connects you with the right content creators.",
    borderBottomColor: "rgba(55, 19, 253, 0.39)",
  },
  {
    id: 4,
    logo: "FaUsersRectangle",
    title: "Efficient Collaboration",
    description: "Efficiently collaborate with skilled content creators. Post your job requirements and watch your project come to life.",
    borderBottomColor: "rgba(19, 120, 175, 0.39)",
  },
  {
    id: 5,
    logo: "FaLightbulb",
    title: "Creative Partnerships",
    description: "Foster creative partnerships with our platform. Post your job requirements and discover talented content creators.",
    borderBottomColor: "rgba(26, 158, 253, 0.39)",
  },
  {
    id: 6,
    logo: "MdJoinRight",
    title: "Connect with Creativity",
    description: "Connect with creativity through our platform. Find and hire content creators who bring your vision to life.",
    borderBottomColor: "rgba(249, 113, 21, 0.39)",
  },
];
